import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { client } from './generated/brezavta/requests/services.gen'
import './i18n'

client.setConfig({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    throwOnError: true, // If you want to handle errors on `onError` callback of `useQuery` and `useMutation`, set this to `true`
})

Sentry.init({
    enabled: import.meta.env.PROD,
    dsn: 'https://01d96dd846585c229c61f05e579de2d1@o1099481.ingest.us.sentry.io/4508429312196608',
    integrations: [],
    release: __BREZAVTA_VERSION__,
})

const root = ReactDOM.createRoot(document.getElementById('root')!, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack)
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Caught error', error, errorInfo.componentStack)
    }),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Recoverable error', error, errorInfo.componentStack)
    }),
})
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
